export default [{"url":"https://hayzedd-test3-0.api.invexerp.io","name":"Branch 1","port":"5029","isStore":true,"isHQ":true}]